import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AdminPanelPage from './pages';
import ComponentsPage, { componentsPageInfo } from './pages/CmsComponents';
import CmsPagesPage, { pageAdminInfo } from './pages/CmsPages';
import WhitelistPage, { whitelistPageInfo } from './pages/Whitelist';

const AdminView: FC = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route exact path={`${path}`} component={AdminPanelPage} />
        <Route
          exact
          path={`${path}/${componentsPageInfo.path}`}
          component={ComponentsPage}
        />
        <Route
          exact
          path={`${path}/${pageAdminInfo.path}`}
          component={CmsPagesPage}
        />
        <Route
          exact
          path={`${path}/${whitelistPageInfo.path}`}
          component={WhitelistPage}
        />
      </Switch>
    </>
  );
};

export default AdminView;
